import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { ContainerApi } from "../../apis/api/DataApi";
import { CountryList } from "../../apis/api/CountryList";
import { AirportMaster, CommudityMaster, IMOMaster, UNMaster } from "../../apis/api/DataApi";
import { insertFreightRequest } from "../../apis/api/FreightRerquestApi";
import Lodderr from "../Lodder/Lodder";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./FreightRequest.css";

const transport = [
  { value:"lcl",          label:"LCL — Less Container Load" },
  { value:"fcl",          label:"FCL — Full Container Load" },
  { value:"air_freight",  label:"Air Freight" },
];
const shipping = [
  { value:"FOB",      label:"FOB" },
  { value:"FCA",      label:"FCA" },
  { value:"EX_WORKS", label:"EX_WORKS" },
];

/* shared react-select styles */
const rsStyles = (hasError) => ({
  control:(b,s)=>({ ...b, borderRadius:"10px", minHeight:"42px",
    border: `1.5px solid ${hasError?"#ef4444": s.isFocused?"#586AD9":"#e5e7eb"}`,
    boxShadow: s.isFocused?"0 0 0 3px rgba(88,106,217,.10)":"none",
    background: "#fafafa", fontSize:".875rem",
    "&:hover":{ borderColor: hasError?"#ef4444":"#586AD9" } }),
  option:(b,s)=>({ ...b, fontSize:".875rem",
    background: s.isSelected?"#586AD9": s.isFocused?"#eef0fb":"#fff",
    color: s.isSelected?"#fff":"#0f172a" }),
  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
  menu: (b) => ({ ...b, zIndex: 9999 }),
});

const New_Request = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedCountry,  setSelectedCountry]  = useState(null);
  const [selectedIMO,      setSelectedIMO]      = useState(null);
  const [visible,          setVisible]          = useState(false);
  const [selectedOption,   setSelectedOption]   = useState(null);
  const [portmasteroption, setPortmasteroption] = useState([]);

  const { register, handleSubmit, reset, control, formState:{ errors } } = useForm();

  useEffect(() => {
    dispatch(ContainerApi());
    dispatch(CountryList());
    dispatch(AirportMaster());
    dispatch(CommudityMaster());
    dispatch(IMOMaster());
    dispatch(UNMaster());
  }, []);

  const { containerlist }                                    = useSelector(s => s.DataSlice);
  const { country }                                          = useSelector(s => s.countrySlice);
  const { airportMaster, portMaster, commudityMaster, imoMaster, unMaster } = useSelector(s => s.DataSlice);
  const { loading }                                          = useSelector(s => s.FreightRequest);

  useEffect(() => {
    if (!selectedOption || !selectedCountry) return;
    const countryId = selectedCountry?.value?.split(":")[0];
    const list = selectedOption === "air_freight"
      ? airportMaster.filter(a => a.CountryId == countryId)
      : portMaster.filter(a => a.CountryId == countryId);
    setPortmasteroption(list);
  }, [selectedOption, selectedCountry, airportMaster, portMaster]);

  const unmasteroption = unMaster.filter(un => {
    if (!selectedIMO?.imoValue) return false;
    return selectedIMO.imoValue.split(".")[1]?.includes(un.unId);
  });

  const onSubmit = async (data) => {
    const formData = new FormData();
    const userId = Cookies.get("userID");
    Object.keys(data).forEach(key => {
      if (data[key]) {
        formData.append(key, typeof data[key]==="object" ? (data[key].value || JSON.stringify(data[key])) : data[key]);
      }
    });
    formData.append("userId", userId);
    try {
      const response = await dispatch(insertFreightRequest(formData)).unwrap();
      reset();
      navigate("/sent_request");
      toast.success(response.message);
    } catch (error) {
      toast.error(error.msz || error.message || "No Member In Selected Destination!");
    }
  };

  const transportLabel = { lcl:"LCL", fcl:"FCL", air_freight:"Air Freight" };

  return (
    <>
      {loading && <Lodderr />}
      <motion.div className="fr-page"
        initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }}
        transition={{ duration:.4, ease:[.22,.68,0,1.2] }}>

        {/* ── BANNER ── */}
        <div className="fr-banner">
          <div>
            <h1 className="fr-banner-title">New Freight Request</h1>
            <p className="fr-banner-sub">Fill in the details below to create a new freight request.</p>
          </div>
          <span className="fr-banner-icon"><i className="bx bx-package"></i></span>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">

          {/* ── TRANSPORT MODULE ── */}
          <motion.div className="fr-card"
            initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }}
            transition={{ delay:.08 }}>
            <div className="fr-card-head">
              <span className="fr-card-head-icon"><i className="bx bx-transfer"></i></span>
              <h2>Transportation Module</h2>
            </div>
            <div className="fr-card-body">
              <div className="fr-field" style={{ maxWidth:420 }}>
                <label className="fr-label">Transport Type <span>*</span></label>
                <Controller name="transportation" control={control}
                  rules={{ required:"Please select transportation" }}
                  render={({ field }) => (
                    <Select {...field} options={transport}
                      placeholder="Select transportation module"
                      styles={rsStyles(!!errors.transportation)}
                      menuPortalTarget={document.body} menuPosition="fixed"
                      onChange={v => { field.onChange(v); setSelectedOption(v?.value||""); }} />
                  )} />
                {errors.transportation && <span className="fr-error">{errors.transportation.message}</span>}
              </div>

              {/* LCL fields */}
              <AnimatePresence>
                {selectedOption === "lcl" && (
                  <motion.div className="fr-grid-3" style={{ marginTop:"1rem" }}
                    initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:"auto" }}
                    exit={{ opacity:0, height:0 }} transition={{ duration:.25 }}>
                    <div className="fr-field">
                      <label className="fr-label">Volume (cbm) <span>*</span></label>
                      <input type="number" className={`fr-input ${errors.lcl_volume?"error":""}`}
                        {...register("lcl_volume",{ required:"Volume is required", min:{ value:1, message:"Min 1" } })} />
                      {errors.lcl_volume && <span className="fr-error">{errors.lcl_volume.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Weight (kgs) <span>*</span></label>
                      <input type="number" className={`fr-input ${errors.lcl_weight?"error":""}`}
                        {...register("lcl_weight",{ required:"Weight is required", min:{ value:1, message:"Min 1" } })} />
                      {errors.lcl_weight && <span className="fr-error">{errors.lcl_weight.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Dimensions (cm) <span>*</span></label>
                      <input type="text" placeholder="length/width/height"
                        className={`fr-input ${errors.lcl_dimensions?"error":""}`}
                        {...register("lcl_dimensions",{ required:"Dimensions are required" })} />
                      {errors.lcl_dimensions && <span className="fr-error">{errors.lcl_dimensions.message}</span>}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* FCL fields */}
              <AnimatePresence>
                {selectedOption === "fcl" && (
                  <motion.div className="fr-grid-3" style={{ marginTop:"1rem" }}
                    initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:"auto" }}
                    exit={{ opacity:0, height:0 }} transition={{ duration:.25 }}>
                    <div className="fr-field">
                      <label className="fr-label">Container Type <span>*</span></label>
                      <Controller name="fcl_container_type" control={control}
                        rules={{ required:"Container Type is required" }}
                        render={({ field }) => (
                          <Select {...field} options={containerlist}
                            placeholder="Select container type"
                            styles={rsStyles(!!errors.fcl_container_type)} menuPortalTarget={document.body} menuPosition="fixed" />
                        )} />
                      {errors.fcl_container_type && <span className="fr-error">{errors.fcl_container_type.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Container Qty <span>*</span></label>
                      <input type="number" className={`fr-input ${errors.fcl_container_count?"error":""}`}
                        {...register("fcl_container_count",{ required:"Quantity is required", min:{ value:1, message:"Min 1" } })} />
                      {errors.fcl_container_count && <span className="fr-error">{errors.fcl_container_count.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Weight (kg) <span>*</span></label>
                      <input type="number" className={`fr-input ${errors.fcl_container_weight?"error":""}`}
                        {...register("fcl_container_weight",{ required:"Weight is required", min:{ value:1, message:"Min 1" } })} />
                      {errors.fcl_container_weight && <span className="fr-error">{errors.fcl_container_weight.message}</span>}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Air Freight fields */}
              <AnimatePresence>
                {selectedOption === "air_freight" && (
                  <motion.div className="fr-grid-3" style={{ marginTop:"1rem" }}
                    initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:"auto" }}
                    exit={{ opacity:0, height:0 }} transition={{ duration:.25 }}>
                    <div className="fr-field">
                      <label className="fr-label">CTNS/QTY <span>*</span></label>
                      <input type="text" className={`fr-input ${errors.air_freight_pcs?"error":""}`}
                        {...register("air_freight_pcs",{ required:"CTNS/QTY is required", pattern:{ value:/^[0-9]+$/, message:"Numbers only" } })} />
                      {errors.air_freight_pcs && <span className="fr-error">{errors.air_freight_pcs.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Gross Weight (kg) <span>*</span></label>
                      <input type="text" className={`fr-input ${errors.air_freight_kgs?"error":""}`}
                        {...register("air_freight_kgs",{ required:"Gross Weight is required", pattern:{ value:/^[0-9]+(\.[0-9]+)?$/, message:"Valid weight required" } })} />
                      {errors.air_freight_kgs && <span className="fr-error">{errors.air_freight_kgs.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">Dimensions <span>*</span></label>
                      <input type="text" className={`fr-input ${errors.air_freight_cbm?"error":""}`}
                        {...register("air_freight_cbm",{ required:"Dimensions are required" })} />
                      {errors.air_freight_cbm && <span className="fr-error">{errors.air_freight_cbm.message}</span>}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>

          {/* ── ORIGIN + DESTINATION ── */}
          <motion.div className="fr-card"
            initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }}
            transition={{ delay:.14 }}>
            <div className="fr-card-head">
              <span className="fr-card-head-icon"><i className="bx bx-map"></i></span>
              <h2>Route Details</h2>
            </div>
            <div className="fr-card-body" style={{ display:"flex", flexDirection:"column", gap:"1.25rem" }}>

              {/* Origin */}
              <div>
                <p className="fr-sub-head"><i className="bx bx-map-pin"></i> Origin</p>
                <div className="fr-grid-2">
                  <div className="fr-field">
                    <label className="fr-label">Country <span>*</span></label>
                    <Controller name="OriginLocationCountry" control={control}
                      rules={{ required:"Location is required" }}
                      render={({ field }) => (
                        <Select {...field} options={country} placeholder="Select country"
                          styles={rsStyles(!!errors.OriginLocationCountry)}
                          menuPortalTarget={document.body} menuPosition="fixed"
                          onChange={v => { field.onChange(v); setSelectedCountry(v); }} />
                      )} />
                    {errors.OriginLocationCountry && <span className="fr-error">{errors.OriginLocationCountry.message}</span>}
                  </div>
                  <div className="fr-field">
                    <label className="fr-label">POL <span>*</span></label>
                    <Controller name="POL" control={control}
                      rules={{ required:"POL is required" }}
                      render={({ field }) => (
                        <Select {...field} options={portmasteroption} placeholder="Port of Loading"
                          styles={rsStyles(!!errors.POL)} menuPortalTarget={document.body} menuPosition="fixed" />
                      )} />
                    {errors.POL && <span className="fr-error">{errors.POL.message}</span>}
                  </div>
                </div>
              </div>

              {/* Destination */}
              <div>
                <p className="fr-sub-head"><i className="bx bx-map-alt"></i> Destination</p>
                <div className="fr-grid-2">
                  <div className="fr-field">
                    <label className="fr-label">Country <span>*</span></label>
                    <Controller name="LocationCountry" control={control}
                      rules={{ required:"Location is required" }}
                      render={({ field }) => (
                        <Select {...field} options={country} placeholder="Select country"
                          styles={rsStyles(!!errors.LocationCountry)}
                          menuPortalTarget={document.body} menuPosition="fixed"
                          onChange={v => { field.onChange(v); setSelectedCountry(v); }} />
                      )} />
                    {errors.LocationCountry && <span className="fr-error">{errors.LocationCountry.message}</span>}
                  </div>
                  <div className="fr-field">
                    <label className="fr-label">POD <span>*</span></label>
                    <Controller name="POD" control={control}
                      rules={{ required:"POD is required" }}
                      render={({ field }) => (
                        <Select {...field} options={portmasteroption} placeholder="Port of Discharge"
                          styles={rsStyles(!!errors.POD)} menuPortalTarget={document.body} menuPosition="fixed" />
                      )} />
                    {errors.POD && <span className="fr-error">{errors.POD.message}</span>}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* ── SHIPPING TERM ── */}
          <motion.div className="fr-card"
            initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }}
            transition={{ delay:.18 }}>
            <div className="fr-card-head">
              <span className="fr-card-head-icon"><i className="bx bx-ship"></i></span>
              <h2>Shipping Term</h2>
            </div>
            <div className="fr-card-body">
              <div className="fr-field" style={{ maxWidth:420 }}>
                <label className="fr-label">Shipping Term <span>*</span></label>
                <Controller name="shippingTerm" control={control}
                  rules={{ required:"Shipping term is required" }}
                  render={({ field }) => (
                    <Select {...field} options={shipping} placeholder="Select shipping term"
                      styles={rsStyles(!!errors.shippingTerm)} menuPortalTarget={document.body} menuPosition="fixed" />
                  )} />
                {errors.shippingTerm && <span className="fr-error">{errors.shippingTerm.message}</span>}
              </div>
            </div>
          </motion.div>

          {/* ── COMMODITY ── */}
          <motion.div className="fr-card"
            initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }}
            transition={{ delay:.22 }}>
            <div className="fr-card-head">
              <span className="fr-card-head-icon"><i className="bx bx-box"></i></span>
              <h2>Commodity Details</h2>
            </div>
            <div className="fr-card-body" style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
              <div className="fr-note">
                <i className="bx bx-info-circle"></i>
                All non-temperature-controlled cargo is quoted under "Dry cargo — Freight all kinds". This includes dangerous and liquid goods that do not require temperature control.
              </div>
              <div className="fr-field" style={{ maxWidth:480 }}>
                <label className="fr-label">Commodity <span>*</span></label>
                <Controller name="Commodity" control={control}
                  rules={{ required:"Commodity is required" }}
                  render={({ field }) => (
                    <Select {...field} options={commudityMaster} placeholder="Select commodity"
                      styles={rsStyles(!!errors.Commodity)} menuPortalTarget={document.body} menuPosition="fixed" />
                  )} />
                {errors.Commodity && <span className="fr-error">{errors.Commodity.message}</span>}
              </div>

              {/* Dangerous cargo toggle */}
              <label className="fr-checkbox-row">
                <input type="checkbox" name="dangerous_cargo" value="1"
                  onChange={e => setVisible(e.target.checked)} />
                <i className="bx bx-error-circle" style={{ color:"#ef4444", fontSize:"1rem" }}></i>
                <span>Dangerous Cargo</span>
              </label>

              <AnimatePresence>
                {visible && (
                  <motion.div className="fr-grid-2"
                    initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:"auto" }}
                    exit={{ opacity:0, height:0 }} transition={{ duration:.25 }}>
                    <div className="fr-field">
                      <label className="fr-label">IMO Classification <span>*</span></label>
                      <Controller name="IMO_classification" control={control}
                        rules={{ required:"IMO Classification is required" }}
                        render={({ field }) => (
                          <Select {...field} options={imoMaster} placeholder="Select IMO"
                            styles={rsStyles(!!errors.IMO_classification)}
                            menuPortalTarget={document.body} menuPosition="fixed"
                            onChange={v => { field.onChange(v); setSelectedIMO(v); }} />
                        )} />
                      {errors.IMO_classification && <span className="fr-error">{errors.IMO_classification.message}</span>}
                    </div>
                    <div className="fr-field">
                      <label className="fr-label">UN Number <span>*</span></label>
                      <Controller name="UN_number" control={control}
                        rules={{ required:"UN number is required" }}
                        render={({ field }) => (
                          <Select {...field} options={unmasteroption} placeholder="Select UN number"
                            styles={rsStyles(!!errors.UN_number)} menuPortalTarget={document.body} menuPosition="fixed" />
                        )} />
                      {errors.UN_number && <span className="fr-error">{errors.UN_number.message}</span>}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>

          {/* ── DATE + COMMENT ── */}
          <motion.div className="fr-card"
            initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }}
            transition={{ delay:.26 }}>
            <div className="fr-card-head">
              <span className="fr-card-head-icon"><i className="bx bx-calendar"></i></span>
              <h2>Additional Details</h2>
            </div>
            <div className="fr-card-body" style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
              <div className="fr-field" style={{ maxWidth:320 }}>
                <label className="fr-label">Issue Date of Loading <span>*</span></label>
                <input type="date" className={`fr-input ${errors.issueDate?"error":""}`}
                  {...register("issueDate",{ required:"Date is required" })} />
                {errors.issueDate && <span className="fr-error">{errors.issueDate.message}</span>}
              </div>
              <div className="fr-field">
                <label className="fr-label">Comment <span>*</span></label>
                <textarea rows={3} placeholder="Add any notes about this request…"
                  className={`fr-input ${errors.comment?"error":""}`}
                  {...register("comment",{ required:"Comment is required" })} />
                {errors.comment && <span className="fr-error">{errors.comment.message}</span>}
              </div>
            </div>
            <div className="fr-footer">
              <button type="submit" className="fr-submit">
                <i className="bx bx-send"></i> Submit Request
              </button>
            </div>
          </motion.div>

        </form>
      </motion.div>
    </>
  );
};

export default New_Request;
